module.exports = __webpack_public_path__ + "img/feira-indigena.1b721ccd.jpg";